import { useMantineTheme } from '@mantine/core';
import { getFileExtensionConfig } from '@repo/common/utils/fileExtensionConfig';
import { Icon } from '@repo/foundations';
import styled from 'styled-components';

type Props = {
	title: string;
	size?: number;
};

export default function FileExtension(props: Props) {
	const theme = useMantineTheme();
	const parts = props.title.split('.');
	const extension = parts.length > 1 ? parts.pop() : undefined;

	const extensionConfig = getFileExtensionConfig(extension ?? '');

	return (
		<IconContainer
			style={{ background: theme.other.getColor(extensionConfig.color) }}
			$size={props.size || 28}
		>
			<Icon color={extensionConfig.text} name={extensionConfig.icon} />
		</IconContainer>
	);
}

const IconContainer = styled.span<{ $size: number }>`
	font-family: ${(props) => props.theme.fontFamilyMono};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	text-transform: uppercase;
	text-align: center;
	border-radius: 4px;

	min-width: ${(props) => props.$size}px;
	height: ${(props) => props.$size}px;
`;
